
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/credittent",
      function () {
        return require("private-next-pages/credittent/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/credittent"])
      });
    }
  